import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UniqueEntityID } from '@digibricks/domains';
import { Assignment } from './assignment';
export var HomeworkAssignment = /*#__PURE__*/function (_Assignment) {
  _inherits(HomeworkAssignment, _Assignment);

  var _super = _createSuper(HomeworkAssignment);

  function HomeworkAssignment() {
    _classCallCheck(this, HomeworkAssignment);

    return _super.apply(this, arguments);
  }

  _createClass(HomeworkAssignment, [{
    key: "publishScoreInformation",
    get: function get() {
      return this.props.publishScoreInformation;
    }
  }, {
    key: "isAllowToEditSubmission",
    get: function get() {
      return this.props.isAllowToEditSubmission;
    }
  }, {
    key: "numberOfEditSubmissionTime",
    get: function get() {
      return this.props.numberOfEditSubmissionTime;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var validatedBasePropsOrError = _get(_getPrototypeOf(HomeworkAssignment), "validateBaseProps", this).call(this, props);

      if (validatedBasePropsOrError.isFailure) {
        return Result.fail(validatedBasePropsOrError.error);
      }

      return Result.ok(new HomeworkAssignment(props, new UniqueEntityID(props.id)));
    }
  }]);

  return HomeworkAssignment;
}(Assignment);